import React from "react";
//import features from Material UI libraries
import { Button, Grid, Stack, Typography } from "@mui/material";
import Item from "@mui/material/Stack";
import SocialMedia from "../components/socialMedia.jsx";
//main funtion for export
export default function CV() {
  return (
    <Grid
      container
      spacing={6}
      display="flex"
      direction="row"
      align="center"
      alignItems="flex-start"
    >
      <Grid item xs={12} md={1}>
        <SocialMedia />
      </Grid>
      {/* sx={{ mx: "5%" }} sx={{ mb: 4 }}*/}
      <Grid item xs={12} md={7} sx={{ mt: 5 }}>
        <Typography variant="h1" className="title">
          Lauritta Burrows CV{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} sx={{ mt: 5 }}>
        <Button
          sx={{ mt: 4, mx: 3 }}
          color="secondary"
          variant="outlined"
          size="large"
          href="/documents/Lauritta Burrows CV - Software Developer October 2025.docx"
          className="download"
        >
          <Typography variant="h5" color="secondary">
            View CV
          </Typography>
        </Button>
      </Grid>
      <Grid item md={1} align="left">
        {"  "}
      </Grid>
      <Grid item sm={12} md={4} align="left">
        <Stack spacing={4}>
          <Item>
            <Typography variant="h4" className="title">
              Education
            </Typography>
            <Typography component={"ul"} variant="body1" className="darkFont">
              <li>BSc Computer Science 2025</li>
              <li>University of West London</li>
              <li>First Class Honours</li>
            </Typography>
          </Item>
          <Item>
            <Typography variant="h4" className="title">
              Certifications
            </Typography>
            <Typography component={"ul"} variant="body1" className="darkFont">
              <li>MS Azure Fundamentals</li>
              <li>Scrum Fundamentals Certified</li>
              <li>ITIL v4 Foundation</li>
            </Typography>
          </Item>
          <Item>
            <Typography variant="h4" className="title">
              Interests
            </Typography>
            <Typography component={"ul"} variant="body1" className="darkFont">
              <li>Self-assembled servers</li>
              <li>SUP boarding</li>
              <li>Camping</li>
            </Typography>
          </Item>
        </Stack>
      </Grid>
      <Grid item sm={12} md={3} align="left">
        <Typography variant="h4" className="title">
          Skills
        </Typography>
        <Typography component={"ul"} variant="body1" className="darkFont">
          <li><strong>Backend & Databases:</strong> Node.js, PostgreSQL, MS SQL Server, Sequelize CLI, RESTful APIs</li>
          <li><strong>Programming Languages:</strong> JavaScript, Java, TypeScript, Python</li>
          <li><strong>Frontend:</strong> D3.js, Nuxt, Vue.js. React, HTML5, CSS (including Tailwind, MUI & Bootstrap)</li>
          <li><strong>Tools & Practices:</strong> GitHub, Azure DevOps, Docker, Agile & Scrum, Automated Testing, OpenAPI/Swagger</li>
        </Typography>
      </Grid>
      <Grid item sm={12} md={4} align="left">
        <Typography variant="h4" className="title">
          Courses
        </Typography>
        <Typography component={"ul"} variant="body1" className="darkFont">
          <li>2025 Microsoft Azure Fundamentals</li>
          <li>2025 Java SE 17 Developer</li>
          <li>2025 Duolingo Spanish</li>
          <li>2024 Typescript</li>
          <li>2022 Microsoft Azure Fundamentals</li>
          <li>2022 SQLite3 & Node js</li>
          <li>2021 React & Material UI</li>
          <li>2020 Web Programming & Javascript</li>
          <li>2019 Level 2 IT User & Java</li>
          <li>2019 Level 2 Lean Organisational Management Techniques</li>
          <li>2018 Linux & Python</li>
          <li>2017 HTML</li>
        </Typography>
      </Grid>
    </Grid>
  );
}
